// extracted by mini-css-extract-plugin
export default {"mainContainer":"BrainFunction_mainContainer__73hhw","barGraph":"BrainFunction_barGraph__9-GFq","barCompenent":"BrainFunction_barCompenent__r7ZNv","bar":"BrainFunction_bar__D6vAC"};